import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';

import { EventsForm } from './EventsForm';

export function SettingsEventsPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">{messages.settingsEventsTitle}</h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsEventsSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsEventsListTitle}
        </h3>
      </div>
      <EventsForm />
    </div>
  );
}
